import './utils/pwaInstallCapture';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './i18n/config';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { initErrorMonitoring, initGlobalErrorHandlers } from './lib/errorReporter.js';

// Sentry 오류 모니터링 및 전역 에러 핸들러 초기화
initErrorMonitoring();
initGlobalErrorHandlers();

// 홈페이지 설치 유입 플래그 캡처 (?install=1)
try {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get('install') === '1') {
    sessionStorage.setItem('PWA_INSTALL_GUIDE', '1');
  }
} catch (_) {}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// 웹 푸시 전용 서비스 워커 등록 (즉시 비동기 등록으로 워커 준비 지연 최소화)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {
    // 등록 실패 시 조용히 무시하여 앱 정상 구동 보장
  });
}

